import { useContext, createContext, useState, useEffect, useRef } from "react";
import { AppContext } from "../App";
import { callApi, WEB_SOCKET_URL } from "../CoreHelper";
import { MdOutlineChat, MdOutlineClear, MdVerticalAlignTop, MdKeyboardArrowLeft, MdOutlineRefresh } from 'react-icons/md';
import { AiOutlineCloseCircle } from 'react-icons/ai';
import PlayedCard from "../components/PlayedCard";
import { AppContext as MainAppContext } from "../../App";
import CardsPlayerInfo from "../ones/CardsPlayerInfo";
import logo_wide from '../assets/logo_wide.png';
import { 
  BsFillSuitDiamondFill,
  BsFillSuitHeartFill,
  BsSuitClubFill,
  BsFillSuitSpadeFill,
  BsFillChatDotsFill,
} from 'react-icons/bs';
import { FaHandsWash } from 'react-icons/fa';
import Arubastini from "../models/Arubastini";
import UserCard from "../components/UserCard";
import MobileInterface from "../../MobileInterface";

export const GameContext = createContext(null);
export default function ArubastiniBoard(props) {

  const app = useContext(AppContext);
  const mainApp = useContext(MainAppContext);
 
  const [ boardLocked, setBoardLocked ] = useState(false);
  const [ error, setError ] = useState(null);
  const [ message, setMessage ] = useState(null);
  const [ selectedCard, setSelectedCard ] = useState(null);

  function getBoardState(_gameData) {
    return JSON.parse(_gameData.boardData).board;
  }
  
  function resetSelections(fromSubmitMove = false) {
    //reset selections here
    setSelectedCard(null);
  }

  function isCurrentPlayer() {
    return (app.gameData && app.gameData.currentPlayer === Number(app.userId) && app.gameData.status === 'ongoing')

  }
  
  function getPlayerCards() {
    let cards = [];
    if(app.gameData) {
      if(app.gameData.playerId === Number(app.userId)) {
        cards = JSON.parse(app.gameData.playerData).availableCards;
      } else if(app.gameData.opponentId === Number(app.userId)) {
        cards = JSON.parse(app.gameData.opponentData).availableCards;
      }
    }

    if(cards) {
      //get cards objects
      const cardObjects = cards.map((item, i) => {
        return Arubastini.getCard(item);
      })

      cards = cardObjects;
    }

    return cards;
  }

  function getMchezo() {
    if(app.gameData) {
      return Arubastini.getCard(JSON.parse(app.gameData.boardData).mchezo);
    }
  }

  function resetSelections() {
    setSelectedCard(null);
  }

  function getScore() {
    if(app.gameData) {
      if(Number(app.userId) === app.gameData.playerId) {
        return JSON.parse(app.gameData.playerData).score;
      } else if(Number(app.userId) === app.gameData.opponentId) {
        return JSON.parse(app.gameData.opponentData).score;
      }
    }
    return 0;
  }

  async function submitMove() {
    if(app.gameData.currentPlayer === Number(app.userId)) {
      if(!boardLocked) {
        if(selectedCard) {
          //...
          setBoardLocked(true);
          setMessage('Syncing, please wait...')
          await callApi("submit-move", {
            userId: app.userId,
            userToken: app.userToken,
            gameId: app.gameId,
            gameType: app.gameType,
            playMode: app.playMode,
            selectedCard,
          }).then(response => {
            if(response.status === 1) {
              //refresh gamedata
              app.getGameData();
              resetSelections();
              setMessage(false);
              setError(false);
            } else {
              setError(response.msg);
              resetSelections();
            }
          })
          setBoardLocked(false);
          //...
        } else {
          setError("Please select a card to play");
        }
      } else {
        setError("Not your turn to play, please wait");
      }
    } else {
      setError("Not your turn to play, please wait..");
    }
  }

  const gameContext = {
    submitMove,
    boardLocked,
    setBoardLocked,
    message,
    error,
    setError,
    setMessage,
    resetSelections,
    getMchezo,
    selectedCard,
    setSelectedCard,
  }

  useEffect(() => {

  }, [ ])

  useEffect(() => {
    //called when gameData changes
    if(app.gameData) {
      if(isCurrentPlayer()) {
        //haptic
        MobileInterface.playSound('vibrate');
      }
    }
  }, [ app.gameData ])

  

  useEffect(() => {
    console.log(error);
  }, [ error ])

  return (
    <GameContext.Provider value={gameContext}>
      <div className="CoreCardsBoard">
        <div className="container">
          
          <div className="row">
            <div className="col-md-12 d-flex justify-content-between">
              <img 
                src={logo_wide} 
                className="align-self-center"
                style={{ 
                  height:"50px", 
                  marginLeft: "0px",
                  marginRight: "10px",
                  marginTop: "10px",
                  marginBottom: "10px", 
                  width: "auto",
                  flexShrink: "0",
                }}
              />

              <div className="d-flex align-self-center justify-content-end">
                <MdOutlineRefresh 
                  style={{
                    marginLeft: "10px",
                    marginRight: "10px",
                    cursor: "pointer"
                  }} 
                  onClick={app.refresh}
                  className="mNoPadding align-self-center" 
                  size={30}
                />

                <button
                  onClick={app.navBack}
                  className="btn btn-sm core-bg-redish align-self-center d-flex"
                  style={{
                    flexShrink: "0",
                    margin: "0",
                    paddingLeft: "5px",
                    paddingRight: "5px",
                    paddingTop: "5px",
                    paddingBottom: "5px",
                    width: "auto"
                  }}
                >
                  <MdKeyboardArrowLeft className="mNoMargin mNoPadding align-self-center" size={30}/>
                </button>
              </div>
            </div>
            <div className="col-md-6">

              <div className="corePlayedCards">
                <CardsPlayerInfo type="player"/>
                <CardsPlayerInfo type="opponent"/>

                <h6 
                  style={{ 
                    fontSize: "12px", 
                    position: "absolute",
                    bottom: "0",
                    width: "100%"
                  }} 
                  className="text-center text-muted font-bold"
                >
                  Draws: {(app.gameData) ? app.gameData.drawsNumber : ""}
                </h6>


                {
                  (app.gameData && JSON.parse(app.gameData.boardData).playedCardsShow.length >= 2 && (JSON.parse(app.gameData.boardData).playedCardsShow.length % 2) === 0) ?
                  JSON.parse(app.gameData.boardData).playedCardsShow.slice(-2).map((item, i) => {
                    return <PlayedCard key={i} position={i} data={Arubastini.getCard(item)}/>
                  })
                  :
                  (app.gameData && JSON.parse(app.gameData.boardData).playedCards.length === 1) ?
                  JSON.parse(app.gameData.boardData).playedCards.map((item, i) => {
                    return <PlayedCard key={i} position={i} data={Arubastini.getCard(item)}/>
                  }): ""
                }

                
              </div>
              <div
                className="row"
              >
                <div 
                  className="col-4" 
                  style={{ padding: "10px" }}
                >
                  <div
                    data-symbol={getMchezo().symbol} 
                    className="coreMchezoHolder text-center"
                  >
                    {
                      (getMchezo()) ?
                      <>
                      {
                        (getMchezo().symbol === 'kisu') ?
                        <>
                          <BsFillSuitDiamondFill
                            className="mSymbol"
                          />
                          
                        </>
                        :null
                      }
                      
                      {
                        (getMchezo().symbol === 'kopa') ?
                        <>
                          <BsFillSuitHeartFill
                            className="mSymbol"
                          />
                        </>
                        :null
                      }

                      {
                        (getMchezo().symbol === 'jembe') ?
                        <>
                          <BsFillSuitSpadeFill
                            className="mSymbol"
                          />
                        </>
                        :null
                      }

                      {
                        (getMchezo().symbol === 'karanga') ?
                        <>
                          <BsSuitClubFill
                            className="mSymbol"
                          />
                        </>
                        :null
                      }
                      </>: ""
                    }

                    <h6 style={{ fontSize: "12px", margin: "0" }} className="font-semi-bold">Mchezo</h6>
                  </div>

                </div>
                <div 
                  className="col-2 text-center" 
                  style={{ padding: "10px" }}
                >
                  <h5 className="font-bold" style={{ fontSize: "25px" }}>{getScore()}</h5>
                  <h6 className="text-muted font-light" style={{ fontSize: "12px" }}>Score</h6>
                </div>
                <div className="col-6" style={{ padding: "10px" }}>
                  <h5
                    style={{
                      fontSize: "20px"
                    }}
                    className="core-text-goldish font-bold"
                  >
                    Arubastini
                  </h5>
                  {
                    (app.webSocketConnected === 0) ?
                    <h6
                      className="font-regular core-text-redish"
                      style={{
                        fontSize: "12px",
                      }}
                    >
                      Lost connection, reconnecting... <br/>Refresh if it takes long
                    </h6>:""
                  }
                  <h6
                    className="font-light"
                    style={{
                      fontSize: "12px",
                      maxHeight: "40px",
                      overflow: "hidden",
                    }}
                  >
                    {error || message}
                  </h6>
                </div>
              </div>
            </div>

            <div className="col-md-6 " >
              

              {
                (isCurrentPlayer()) ?
                <div className="text-center" style={{ width: "100%", marginBottom: "5px" }}>
                  <h6
                    style={{
                      width: "200px",
                      margin: "0 auto",
                      padding: "5px",
                      fontSize: "14px",
                    }}
                    className="core-bg-maronish font-semi-bold"
                  >
                    YOUR TURN TO PLAY
                  </h6>
                </div>:""
              }

              {
                (getPlayerCards().length > 4) ?
                <h6 style={{ fontSize: "12px", margin: "0" }} className="text-start text-muted font-light">Scroll up or down for more cards</h6>
                :""
              }

              <div className="coreCardsRowsHolder">
                
                <div
                  className="coreCardsRow"
                >
                  {
                    (app.gameData) ?
                    <>
                    {
                      getPlayerCards().map((item, i) => {
                        if(i >= 0 && i < 4) {
                          return <UserCard data={item} key={i}/>
                        }
                      })
                    }
                    </>
                    :""
                  }
                </div>

                <div
                  className="coreCardsRow"
                >
                  {
                    (app.gameData) ?
                    <>
                    {
                      getPlayerCards().map((item, i) => {
                        if(i >= 4 && i < 8) {
                          return <UserCard data={item} key={i}/>
                        }
                      })
                    }
                    </>
                    :""
                  }
                </div>

                <div
                  className="coreCardsRow"
                >
                  {
                    (app.gameData) ?
                    <>
                    {
                      getPlayerCards().map((item, i) => {
                        if(i >= 8 && i < 12) {
                          return <UserCard data={item} key={i}/>
                        }
                      })
                    }
                    </>
                    :""
                  }
                </div>

                <div
                  className="coreCardsRow"
                >
                  {
                    (app.gameData) ?
                    <>
                    {
                      getPlayerCards().map((item, i) => {
                        if(i >= 12 && i < 16) {
                          return <UserCard data={item} key={i}/>
                        }
                      })
                    }
                    </>
                    :""
                  }
                </div>

                <div
                  className="coreCardsRow"
                >
                  {
                    (app.gameData) ?
                    <>
                    {
                      getPlayerCards().map((item, i) => {
                        if(i >= 16 && i < 20) {
                          return <UserCard data={item} key={i}/>
                        }
                      })
                    }
                    </>
                    :""
                  }
                </div>

                <div
                  className="coreCardsRow"
                >
                  {
                    (app.gameData) ?
                    <>
                    {
                      getPlayerCards().map((item, i) => {
                        if(i >= 20 && i < 24) {
                          return <UserCard data={item} key={i}/>
                        }
                      })
                    }
                    </>
                    :""
                  }
                </div>

                <div
                  className="coreCardsRow"
                >
                  {
                    (app.gameData) ?
                    <>
                    {
                      getPlayerCards().map((item, i) => {
                        if(i >= 24 && i < 28) {
                          return <UserCard data={item} key={i}/>
                        }
                      })
                    }
                    </>
                    :""
                  }
                </div>

                <div
                  className="coreCardsRow"
                >
                  {
                    (app.gameData) ?
                    <>
                    {
                      getPlayerCards().map((item, i) => {
                        if(i >= 28 && i < 32) {
                          return <UserCard data={item} key={i}/>
                        }
                      })
                    }
                    </>
                    :""
                  }
                </div>
              
              </div>

              <div 
                className="text-center" 
                style={{ 
                  width: "100%",
                }}
              >
                <button onClick={app.triggerChat} className="btn coreCardsActionBtn">
                  <BsFillChatDotsFill
                    className="mIcon"
                  /><br/>
                  Chat
                </button>
                <button onClick={submitMove} className="btn coreCardsActionBtn">
                  <MdVerticalAlignTop
                    className="mIcon"
                  /><br/>
                  Play
                </button>
                <button 
                  onClick={() => {
                    mainApp.activateDialog({
                      message: "Are you sure you want to give up this game and lose?",
                      onConfirm: app.surrenderGame,
                    })
                  }}
                  className="btn coreCardsActionBtn"
                >
                  <FaHandsWash
                    className="mIcon"
                  /><br/>
                  Give Up
                </button>
                <button onClick={resetSelections} className="btn coreCardsActionBtn">
                  <MdOutlineClear
                    className="mIcon"
                  /><br/>
                  Clear
                </button>
              </div>
            </div>

          </div>
          
        </div>
      </div>
    </GameContext.Provider>
  )
}